import { Typography, Card, Statistic, Table, Progress, theme, Space, Popconfirm, Button } from 'antd';
import React from 'react';
import { BidirectionalBar, Column, Liquid, Gauge, Pie, ConfigProvider } from '@ant-design/charts';
import { G2 } from '@ant-design/plots' ;     

import {get} from 'lodash-es';
import { DeleteOutlined, QuestionCircleOutlined } from '@ant-design/icons';

const { Title } = Typography;


type KPIProps = {
    kpiResponse: any,
    title: string,
    onDelete?: () => void
};


function AinaTheme ( ) {  
  // You can modify it based on an existing theme
  const light = G2 . Light ( ) ; 

  // Return to the modified theme configuration
  return { 
    ... light ,
    color : '#4A7BFF',
    category10 : [
        '#4A7BFF',
        '#FF5A4C',
        '#ffeb39ff',
        '#13e254ff',
        '#94cdff',
        '#0b98b1',
        '#daff76ff',
        '#ff96d3',
        '#ba60ff',
        '#b3795c',
    ],
    category20: [
        '#1F77B4',
        '#FF7F0E',
        '#2CA02C',
        '#D62728',
        '#9467BD',
        '#8C564B',
        '#E377C2',
        '#7F7F7F',
        '#BCBD22',
        '#17BECF',
        '#AEC7E8',
        '#FFBB78',
        '#98DF8A',
        '#FF9896',
        '#C5B0D5',
        '#C49C94',
        '#F7B6D2',
        '#C7C7C7',
        '#DBDB8D',
        '#9EDAE5'
    ]
  } ;
}
// 2. Register a topic
G2.register ( 'theme.aina' , AinaTheme ) ; 


/**
 * "BidirectionalBar",
"Column",
"Pie",
"Liquid",
"Gauge",
"Table",
"Progress",
"Statistic"
 */

const ShowGraph = (props: any) => {
    const { data, keyMeta, respresentationType, clientHeight } = props;

    const {
        token: { colorPrimary, colorSuccess, colorWarning, colorError, colorBgBase},
    } = theme.useToken();

    switch (respresentationType) {
        case "BidirectionalBar":
            return <BidirectionalBar 
                theme={'aina'}
                data={data}
                xField={keyMeta.label}
                yField={[keyMeta.value1, keyMeta.value2]}
                style={{
                    fill: (d:any) => {
                        if (d.groupKey === keyMeta.value1) return colorPrimary;
                        return d[keyMeta.value1] > d[keyMeta.value2] ? colorError : colorSuccess;
                    }
                }}
                label={{
                    text: (d:any)=>{
                        return (d.groupKey === keyMeta.value1)? d[keyMeta.value1] : d[keyMeta.value2];
                    },
                    style: {
                        fill: '#FFFFFF',
                    },
                    offset: 10,
                }}
                height={clientHeight - 100 || 250}
            />;
        case "ColumnGrouped":
            return <Column 
                theme={'aina'}
                data={data}
                xField={keyMeta.xField}
                yField={keyMeta.yField}
                colorField={keyMeta.colorField}
                label={{
                    text: (d:any)=>{
                        return d[keyMeta.yField];
                    },
                    position: 'top',
                    dy: -15,
                    style: {
                        fontWeight: 'bold',
                    },
                    transform: [ { type : 'contrastReverse' } ]
                }}
                group={ {
                    padding: 0,
                }}
                height={clientHeight - 100 || 250}
            />;
        case "Statistic":
            return <Statistic 
                title={get(data[0] || data, keyMeta.title, "Title")} 
                value={get(data[0] || data, keyMeta.value, "Value")}
                prefix={keyMeta.prefix ? get(data[0] || data, keyMeta.prefix) : null}
                suffix={keyMeta.suffix ? get(data[0] || data, keyMeta.suffix) : null}
            />;
        case "Table":
            return <Table 
                dataSource={data} 
                columns={(keyMeta && keyMeta.columns) || keyMeta || []} 
                pagination={false}
                size='small'
                rowKey={(record) => record._id || JSON.stringify(record)}
            />;
        case "Progress":
            return <Space direction="vertical" size="middle" align="center">
                <Progress
                    type={get(data[0] || data, 'type', 'line')}
                    percent={get(data[0] || data, 'percentage', 0)}
                    format={(percent) => `${percent} %`}
                    status={get(data[0] || data, 'status', 'active')}
                    showInfo
                />
                {get(data[0] || data, 'format_string') && 
                    <Title level={4} style={{margin: 0}}>
                        {get(data[0] || data, 'format_string')} 
                    </Title>
                }
            </Space>
                
        case "Gauge":
            return <Gauge 
                theme={'aina'}
                autoFit
                data={{
                    target: get(data[0] || data, keyMeta.value, 0),
                    total: get(data[0] || data, keyMeta.total, 100),
                }}
            />
        case "Column":
            return <Column 
                theme={'aina'}
                data={data}
                xField={keyMeta.label}
                yField={keyMeta.value}
                height={clientHeight - 100 || 250}
                color={colorPrimary}
                label={{
                    position: 'bottom',
                    text: (d:any) => d[keyMeta.value],
                    transform: [ { type : 'contrastReverse' } ]
                }}
            />;
        case "Pie":
            // return <Pie 
            //     data={data}
            //     angleField={keyMeta.value}
            //     colorField={keyMeta.label}
            //     radius={1}
            //     height={clientHeight - 20 || 250}
            //     label={{
            //         text: keyMeta.display || keyMeta.value,
            //         postion: 'spider',
            //         // transform : [ { type : 'overlapDodgeY' }, { type: 'contrastReverse'} ],
            //         // style: {
            //         //     fontWeight: 'bold',
            //         // },
            //     }}
            //     tooltip={{
            //         title: (d) => d[keyMeta.label],
            //     }}
            //     legend={{
            //         itemValue: (d:any) => `${d[keyMeta.display] || d[keyMeta.value]}` ,
            //     }}
            //     interactions={[{ type: 'element-active' }]}
            // />;
            const total = data.reduce((sum:any, item:any) => sum + (item[keyMeta.value] || 0), 0);
            const config = {
                theme: 'aina',
                data: data,
                angleField: keyMeta.value,
                colorField: keyMeta.label,
                height: clientHeight - 20 || 250,
                // size: 20,
                radius: 0.7,
                label: {
                    text: (d:any) => `${d[keyMeta.label]} - ${d[keyMeta.value]} (${((d[keyMeta.value]/total)*100).toFixed(2)}%)`,
                    position: 'spider',
                    transform : [ { type : 'overlapDodgeY' }, { type: 'contrastReverse'} ],
                    style: {
                        fontWeight: 'bold',
                    },
                },
                tooltip: {
                    title: (d:any) => d[keyMeta.label],
                },
                // legend: false,
                legend: {
                    itemValue: (d:any) => `${d[keyMeta.display] || d[keyMeta.value]}` ,
                    // orientation: 'vertical',
                    position: 'right',
                    crossPadding: 20,
                    maxRows: 1,
                },
            };
            return <Pie {...config} />;
        case "Liquid":
            return <Liquid 
                percent={get(data[0] || data, 'percentage', 0)/100}
                style={{
                    shape: get(data[0] || data, 'shape', 'circle'),
                    waveLength: 60,
                    textFill: colorBgBase,
                    outlineDistance: 4,
                    contentText: get(data[0] || data, 'format_string', '')
                }}
                height={clientHeight - 20 || 250}
            />

        default:
            return <div>Graph type {respresentationType} not supported yet</div>;
    }
}


const KPIDisplay: React.FC<KPIProps> = (props) => {
    const { kpiResponse, title } = props;
    const { currentData: data, keyMeta, respresentationType } = kpiResponse;

    let cardRef = {current: {clientHeight: 350}};
    let extraProp = {};
    if (typeof props.onDelete == 'function') {
        // cardRef = React.useRef<any>(null);
        extraProp = {ref: cardRef};
    }

    
    if (!data) return null;

    const extras = (
        <Space>
            {typeof props.onDelete == 'function' && <Popconfirm
                title="Remove Widget"
                description="Are you sure to remove this widget?"
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                onConfirm={props.onDelete}
            >
                <Button danger ><DeleteOutlined /></Button>
            </Popconfirm>}
        </Space>
    );

    return (
        respresentationType &&
    <Card size="small"title={title} hoverable extra={extras} style={{ width: '100%', height: '100%', overflow: 'hidden', userSelect: "none" }} {...extraProp}>
        <Card.Grid hoverable={false} style={{ width: '100%', textAlign: 'center', boxShadow: 'none' }} >
            {ShowGraph({ data, keyMeta, respresentationType, clientHeight: cardRef.current?.clientHeight })}
        </Card.Grid>
    </Card>
    );
};

export default KPIDisplay;